export default function desensitizeName(str: string){
    if(null != str && str != undefined){
        if(str.length <= 2){
            return str.substring(0,1) + '*';
        } else{
            return str.substring(0,1) + '*' + str.substring(str.length-1);
        }
    }
   
}